import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import jwt from 'jsonwebtoken';
export var Token = /*#__PURE__*/function () {
  function Token() {
    _classCallCheck(this, Token);
  }

  _createClass(Token, null, [{
    key: "decodeAccessToken",
    value: function decodeAccessToken(value) {
      return jwt.decode(value);
    }
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired(value) {
      var decoded = this.decodeAccessToken(value);
      return decoded.exp < Date.now() / 1000;
    }
  }]);

  return Token;
}();